module.exports = __webpack_public_path__ + "img/4-2-1-3-2-preview-jenny-e.eebaaea5.jpg";